/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Address } from '../models';
// @ts-ignore
import { DomesticV2BoatsBoatIdAddressesGetRequest } from '../models';
/**
 * BoatAddressesApi - axios parameter creator
 * @export
 */
export const BoatAddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all boat addresses
         * @param {string} boatId The boat public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesGet: async (boatId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boatId' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesGet', 'boatId', boatId)
            const localVarPath = `/domestic/v2/boats/{boat_id}/addresses`
                .replace(`{${"boat_id"}}`, encodeURIComponent(String(boatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Show a boat address
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesIdGet: async (boatId: string, id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boatId' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesIdGet', 'boatId', boatId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesIdGet', 'id', id)
            const localVarPath = `/domestic/v2/boats/{boat_id}/addresses/{id}`
                .replace(`{${"boat_id"}}`, encodeURIComponent(String(boatId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a boat addresses
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesIdPatch: async (boatId: string, id: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boatId' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesIdPatch', 'boatId', boatId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesIdPatch', 'id', id)
            const localVarPath = `/domestic/v2/boats/{boat_id}/addresses/{id}`
                .replace(`{${"boat_id"}}`, encodeURIComponent(String(boatId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boatAddressParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new boat addresses
         * @param {string} boatId The boat public_id
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesPost: async (boatId: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'boatId' is not null or undefined
            assertParamExists('domesticV2BoatsBoatIdAddressesPost', 'boatId', boatId)
            const localVarPath = `/domestic/v2/boats/{boat_id}/addresses`
                .replace(`{${"boat_id"}}`, encodeURIComponent(String(boatId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication password required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "password", ["read", "write"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(boatAddressParameters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BoatAddressesApi - functional programming interface
 * @export
 */
export const BoatAddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BoatAddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * List all boat addresses
         * @param {string} boatId The boat public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BoatsBoatIdAddressesGet(boatId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Address>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BoatsBoatIdAddressesGet(boatId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Show a boat address
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BoatsBoatIdAddressesIdGet(boatId: string, id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BoatsBoatIdAddressesIdGet(boatId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a boat addresses
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BoatsBoatIdAddressesIdPatch(boatId: string, id: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BoatsBoatIdAddressesIdPatch(boatId, id, boatAddressParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a new boat addresses
         * @param {string} boatId The boat public_id
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async domesticV2BoatsBoatIdAddressesPost(boatId: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Address>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.domesticV2BoatsBoatIdAddressesPost(boatId, boatAddressParameters, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BoatAddressesApi - factory interface
 * @export
 */
export const BoatAddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BoatAddressesApiFp(configuration)
    return {
        /**
         * List all boat addresses
         * @param {string} boatId The boat public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesGet(boatId: string, options?: any): AxiosPromise<Array<Address>> {
            return localVarFp.domesticV2BoatsBoatIdAddressesGet(boatId, options).then((request) => request(axios, basePath));
        },
        /**
         * Show a boat address
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesIdGet(boatId: string, id: string, options?: any): AxiosPromise<Address> {
            return localVarFp.domesticV2BoatsBoatIdAddressesIdGet(boatId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a boat addresses
         * @param {string} boatId The boat public_id
         * @param {string} id The address UUID
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesIdPatch(boatId: string, id: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: any): AxiosPromise<Address> {
            return localVarFp.domesticV2BoatsBoatIdAddressesIdPatch(boatId, id, boatAddressParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new boat addresses
         * @param {string} boatId The boat public_id
         * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        domesticV2BoatsBoatIdAddressesPost(boatId: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: any): AxiosPromise<Address> {
            return localVarFp.domesticV2BoatsBoatIdAddressesPost(boatId, boatAddressParameters, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BoatAddressesApi - interface
 * @export
 * @interface BoatAddressesApi
 */
export interface BoatAddressesApiInterface {
    /**
     * List all boat addresses
     * @param {string} boatId The boat public_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApiInterface
     */
    domesticV2BoatsBoatIdAddressesGet(boatId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Address>>;

    /**
     * Show a boat address
     * @param {string} boatId The boat public_id
     * @param {string} id The address UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApiInterface
     */
    domesticV2BoatsBoatIdAddressesIdGet(boatId: string, id: string, options?: AxiosRequestConfig): AxiosPromise<Address>;

    /**
     * Update a boat addresses
     * @param {string} boatId The boat public_id
     * @param {string} id The address UUID
     * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApiInterface
     */
    domesticV2BoatsBoatIdAddressesIdPatch(boatId: string, id: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Address>;

    /**
     * Create a new boat addresses
     * @param {string} boatId The boat public_id
     * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApiInterface
     */
    domesticV2BoatsBoatIdAddressesPost(boatId: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig): AxiosPromise<Address>;

}

/**
 * BoatAddressesApi - object-oriented interface
 * @export
 * @class BoatAddressesApi
 * @extends {BaseAPI}
 */
export class BoatAddressesApi extends BaseAPI implements BoatAddressesApiInterface {
    /**
     * List all boat addresses
     * @param {string} boatId The boat public_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApi
     */
    public domesticV2BoatsBoatIdAddressesGet(boatId: string, options?: AxiosRequestConfig) {
        return BoatAddressesApiFp(this.configuration).domesticV2BoatsBoatIdAddressesGet(boatId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Show a boat address
     * @param {string} boatId The boat public_id
     * @param {string} id The address UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApi
     */
    public domesticV2BoatsBoatIdAddressesIdGet(boatId: string, id: string, options?: AxiosRequestConfig) {
        return BoatAddressesApiFp(this.configuration).domesticV2BoatsBoatIdAddressesIdGet(boatId, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a boat addresses
     * @param {string} boatId The boat public_id
     * @param {string} id The address UUID
     * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApi
     */
    public domesticV2BoatsBoatIdAddressesIdPatch(boatId: string, id: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig) {
        return BoatAddressesApiFp(this.configuration).domesticV2BoatsBoatIdAddressesIdPatch(boatId, id, boatAddressParameters, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new boat addresses
     * @param {string} boatId The boat public_id
     * @param {DomesticV2BoatsBoatIdAddressesGetRequest} [boatAddressParameters] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BoatAddressesApi
     */
    public domesticV2BoatsBoatIdAddressesPost(boatId: string, boatAddressParameters?: DomesticV2BoatsBoatIdAddressesGetRequest, options?: AxiosRequestConfig) {
        return BoatAddressesApiFp(this.configuration).domesticV2BoatsBoatIdAddressesPost(boatId, boatAddressParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
